import { defineMessages } from 'react-intl';

export default defineMessages({
  opensInNewTab: {
    id: 'neptune.Link.opensInNewTab',
    defaultMessage: '(opens in new tab)',
  },
});
